import { render, staticRenderFns } from "./UIEditDialog.vue?vue&type=template&id=c0427b54"
import script from "./UIEditDialog.vue?vue&type=script&lang=js"
export * from "./UIEditDialog.vue?vue&type=script&lang=js"
import style0 from "./UIEditDialog.vue?vue&type=style&index=0&id=c0427b54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports